import React from 'react';
import { T } from '../customer/customers.theme';
import { Dialog, DialogHeader, ErrorLine, GhostButton, Spinner } from '../customer/CustomersUI';

/**
 * Are you sure, asked once and the same way.
 *
 * Both deletions on this screen are the same shape — a question, a red button,
 * and the error kept inside the dialog so the thing you are confirming is still
 * on screen when the answer is no.
 *
 * The question itself is passed in, because it is the phone's sentence and the
 * phone words the two differently.
 */
export default function ConfirmDialog({
  title,
  body,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  note,
  onClose,
  onConfirm,
}) {
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState('');

  const confirm = async () => {
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || 'Could not delete. Try again.');
      setBusy(false);
    }
  };

  return (
    <Dialog onClose={onClose} locked={busy} width={400}>
      <div style={{ padding: '22px 24px 24px' }}>
        <DialogHeader title={title} onClose={onClose} locked={busy} />

        <div style={{ fontSize: 14, color: T.ink, lineHeight: 1.6, paddingTop: 18 }}>{body}</div>

        {note ? (
          <div style={{ fontSize: 12, color: T.inkFaint, lineHeight: 1.6, paddingTop: 8 }}>
            {note}
          </div>
        ) : null}

        <div style={{ paddingTop: 16 }}>
          <ErrorLine>{error}</ErrorLine>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: error ? 12 : 20 }}>
          <GhostButton style={{ flex: 1 }} onClick={onClose} disabled={busy}>
            {cancelLabel}
          </GhostButton>
          <button
            type="button"
            onClick={confirm}
            disabled={busy}
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              height: 48,
              background: T.surface,
              border: `1px solid ${T.dangerBorder}`,
              borderRadius: 10,
              font: 'inherit',
              fontSize: 14,
              fontWeight: 700,
              color: T.danger,
              opacity: busy ? 0.6 : 1,
              cursor: busy ? 'not-allowed' : 'pointer',
            }}
          >
            {busy ? <Spinner size={14} /> : null}
            <span>{confirmLabel}</span>
          </button>
        </div>
      </div>
    </Dialog>
  );
}
